module.exports = __webpack_public_path__ + "img/enterprise-figure-1.e52930d0.png";